import { useFormik } from 'formik';
import swal from 'sweetalert';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { createSSOClient } from '../../data/sso-clients';

const validationSchema = Yup.object().shape({
    name: Yup.string().required('Nombre requerido'),
    slug: Yup.string().required('Slug requerido').matches(/^[a-z0-9-]+$/, 'Solo letras minúsculas, números y guiones'),
    issuer_url: Yup.string().required('Issuer URL requerido'),
    client_id: Yup.string().required('Client ID requerido'),
    client_secret: Yup.string().required('Client Secret requerido'),
});

const AddSSOClient = () => {
    const history = useHistory();

    const formik = useFormik({
        initialValues: {
            name: '',
            slug: '',
            issuer_url: '',
            client_id: '',
            client_secret: '',
            is_active: true,
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                await createSSOClient(values);
                await swal('Afinidata', 'Cliente SSO creado correctamente', 'success');
                history.push('/admin/sso-clients');
            } catch (err) {
                swal('Afinidata', 'Error al crear el cliente SSO', 'error');
            }
        },
    });

    const field = (name: string, label: string, type = 'text', placeholder = '') => (
        <div className="form-group">
            <label>{label}</label>
            <input
                type={type}
                name={name}
                className={`form-control ${(formik.errors as any)[name] && (formik.touched as any)[name] ? 'is-invalid' : ''}`}
                value={(formik.values as any)[name]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder={placeholder}
            />
            {(formik.errors as any)[name] && (formik.touched as any)[name] && (
                <div className="invalid-feedback">{(formik.errors as any)[name]}</div>
            )}
        </div>
    );

    return (
        <div className="row">
            <div className="col-md-8 mx-auto">
                <div className="card">
                    <div className="card-header">
                        <h4>Nuevo cliente SSO</h4>
                    </div>
                    <div className="card-body">
                        <form onSubmit={formik.handleSubmit}>
                            {field('name', 'Nombre', 'text', 'Ej: Comfama')}
                            {field('slug', 'Slug', 'text', 'Ej: comfama')}
                            {field('issuer_url', 'Issuer URL', 'text', 'Ej: http://localhost:8085/realms/afinidata')}
                            {field('client_id', 'Client ID', 'text', 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx')}
                            {field('client_secret', 'Client Secret', 'password')}
                            <div className="form-group form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="is_active"
                                    name="is_active"
                                    checked={formik.values.is_active}
                                    onChange={formik.handleChange}
                                />
                                <label className="form-check-label" htmlFor="is_active">Activo</label>
                            </div>
                            <div className="form-group">
                                <button className="btn btn-primary" type="submit">
                                    <i className="fa fa-save"></i> Guardar
                                </button>
                                <Link to="/admin/sso-clients" className="btn btn-secondary ml-2">
                                    <i className="fa fa-arrow-left"></i> Cancelar
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddSSOClient;
